<p>
  <ui-svg-icon [name]="iconNames.AlertWarningFilled" class="notification-icon tw-align-middle"></ui-svg-icon>
  <span class="notification-message">
    {{ 'administration.hub.timezoneMessage' | translate : { timezone: timezoneText } }}
  </span>
</p>
